import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from '@phosphor-icons/react';
import { EventDropNav } from '../components/EventDropLogo';
import SuppliersSection from '../components/SuppliersSection';

/**
 * Dedicated Studio Pass marketing page — deep-link destination for existing
 * suppliers, email campaigns and "Upgrade to Studio Pass" CTAs.
 */
const StudioPassPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0F1014] text-white">
      <EventDropNav />
      <div className="max-w-5xl mx-auto px-6 pt-10">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
          data-testid="studio-pass-back"
        >
          <ArrowLeft size={14} weight="bold" /> Back
        </button>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <SuppliersSection />
      </motion.div>

      <footer className="border-t border-white/5 py-8 text-center text-xs text-gray-600">
        <p>{'\u00A9'} {new Date().getFullYear()} EventDrop. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default StudioPassPage;
